module.exports = __webpack_public_path__ + "img/1.aad58bbe.png";